import "./HomePage.css";
import React from "react";

const NotFoundPage = () => {
  return (
    <div id="NOTFOUND">
      <h1>Página No Encontrada</h1>
      <p>Es posible que el link esté mal escrito o la función ya no exista.</p>
    </div>
  );
};

export default NotFoundPage;
